export enum FeedbackCardTypeEnum {
  default = 'default',
  success = 'success',
  warning = 'warning',
  error = 'error'
}

export enum ToastPositionEnum {
  'top-right' = 'top-right',
  'top-center' = 'top-center',
  'top-left' = 'top-left',
  'bottom-right' = 'bottom-right',
  'bottom-center' = 'bottom-center',
  'bottom-left' = 'bottom-left'
}
